import {
  Eye,
  FileText,
  Palette,
  Play,
  Puzzle,
} from "lucide-react";

const PLUGIN_ICON_MAP = {
  eye: Eye,
  "file-text": FileText,
  palette: Palette,
  play: Play,
  puzzle: Puzzle,
} as const;

function normalizeIconName(name: string) {
  return name.trim().toLowerCase();
}

export function PluginIcon({
  name,
  className,
}: {
  name: string;
  className?: string;
}) {
  const Icon =
    PLUGIN_ICON_MAP[normalizeIconName(name) as keyof typeof PLUGIN_ICON_MAP] ??
    Puzzle;

  return <Icon className={className} />;
}
